import React, { useEffect } from "react";

const Achievements = () => {
  useEffect(() => {
    const counters = document.querySelectorAll(".counter");
    const speed = 50;

    const animateCounter = (counter) => {
      const target = parseInt(counter.getAttribute("data-target"), 10);
      const increment = target / speed;
      let current = 0;

      const updateCounter = () => {
        current += increment;
        if (current < target) {
          const formatted = Math.floor(current).toLocaleString("en-IN");
          counter.textContent = formatted;
          requestAnimationFrame(updateCounter);
        } else {
          counter.textContent = target.toLocaleString("en-IN");
        }
      };

      updateCounter();
    };

    const achievementsSection = document.getElementById("achievements");
    if (!achievementsSection) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            counters.forEach((counter) => {
              if (counter.textContent === "0") {
                animateCounter(counter);
              }
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(achievementsSection);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="achievements" className="py-5">
      <div className="container-xl px-4 px-md-3 py-5">
        <div className="text-center mb-5">
          <p className="text-success fw-semibold text-uppercase mb-2 small">
            Our Achievements
          </p>
          <h2 className="fw-bold display-6 mb-2">
            Making Healthcare Accessible
          </h2>
          <p className="text-muted mb-0 col-md-8 mx-auto">
            Numbers that reflect our commitment to revolutionizing healthcare
            access across India.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          {/* Onboarded Doctors */}
          <div className="col-md-6 col-lg-3">
            <div className="achievement-card text-center p-4 h-100">
              <div className="achievement-icon mb-3">
                <div className="icon-wrapper">
                  <i className="fa-solid fa-user-doctor"></i>
                </div>
              </div>
              <div className="achievement-number mb-2">
                <span className="counter" data-target="150">
                  0
                </span>
                <span className="plus-sign">+</span>
              </div>
              <h6 className="achievement-title fw-semibold mb-1">
                Onboarded Doctors
              </h6>
              <p className="achievement-desc text-muted small mb-0">
                Expert medical professionals
              </p>
            </div>
          </div>

          {/* Registered Patients */}
          <div className="col-md-6 col-lg-3">
            <div className="achievement-card text-center p-4 h-100">
              <div className="achievement-icon mb-3">
                <div className="icon-wrapper">
                  <i className="fa-solid fa-users"></i>
                </div>
              </div>
              <div className="achievement-number mb-2">
                <span className="counter" data-target="50000">
                  0
                </span>
                <span className="plus-sign">+</span>
              </div>
              <h6 className="achievement-title fw-semibold mb-1">
                Registered Patients
              </h6>
              <p className="achievement-desc text-muted small mb-0">
                Trusted healthcare seekers
              </p>
            </div>
          </div>

          {/* Tokens Booked */}
          <div className="col-md-6 col-lg-3">
            <div className="achievement-card text-center p-4 h-100">
              <div className="achievement-icon mb-3">
                <div className="icon-wrapper">
                  <i className="fa-solid fa-ticket"></i>
                </div>
              </div>
              <div className="achievement-number mb-2">
                <span className="counter" data-target="250000">
                  0
                </span>
                <span className="plus-sign">+</span>
              </div>
              <h6 className="achievement-title fw-semibold mb-1">
                Tokens Booked
              </h6>
              <p className="achievement-desc text-muted small mb-0">
                Online &amp; offline bookings
              </p>
            </div>
          </div>

          {/* Cities Served */}
          <div className="col-md-6 col-lg-3">
            <div className="achievement-card text-center p-4 h-100">
              <div className="achievement-icon mb-3">
                <div className="icon-wrapper">
                  <i className="fa-solid fa-map-location-dot"></i>
                </div>
              </div>
              <div className="achievement-number mb-2">
                <span className="counter" data-target="25">
                  0
                </span>
                <span className="plus-sign">+</span>
              </div>
              <h6 className="achievement-title fw-semibold mb-1">
                Cities Served
              </h6>
              <p className="achievement-desc text-muted small mb-0">
                Across India
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Achievements;
